import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { PortalAuthProvider } from "./context/PortalAuthContext";
import { Toaster } from "sonner";

// Components
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import PortalLayout from "./components/PortalLayout";

import ProviderDashboard from "./pages/ProviderDashboard";
import InstanceSetup from "./pages/InstanceSetup";

// Pages
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Vehicles from "./pages/Vehicles";
import VehicleDetail from "./pages/VehicleDetail";
import Maintenance from "./pages/Maintenance";
import Customers from "./pages/Customers";
import Bookings from "./pages/Bookings";
import BookingDetail from "./pages/BookingDetail";
import CalendarPage from "./pages/Calendar";
import Invoices from "./pages/Invoices";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Accidents from "./pages/Accidents";
import Documents from "./pages/Documents";
import IntegrationWhatsApp from "./pages/IntegrationWhatsApp";
import Messages from "./pages/Messages";
import Emails from "./pages/Emails";
import CustomerDetail from "./pages/CustomerDetail";
import Quotes from "./pages/Quotes";
import Stations from "./pages/Stations";
import Categories from "./pages/Categories";
import Damages from "./pages/Damages";
import Cashbook from "./pages/Cashbook";
import Deposits from "./pages/Deposits";
import Inquiries from "./pages/Inquiries";
import PaymentSuccess from "./pages/PaymentSuccess";
import ScanPage from "./pages/ScanPage";
import SupplierSettlements from "./pages/SupplierSettlements";
import BookingCard from "./pages/BookingCard";
import TrafficTickets from "./pages/TrafficTickets";
import CustomerOnboardings from "./pages/CustomerOnboardings";
import PublicOnboarding from "./pages/PublicOnboarding";
import PublicBooking from "./pages/PublicBooking";
import RegisterStart from "./pages/RegisterStart";
import Letters from "./pages/Letters";
import LongTermContracts from "./pages/LongTermContracts";
import LongTermContractDetail from "./pages/LongTermContractDetail";
import Dunning from "./pages/Dunning";
import DatevExport from "./pages/DatevExport";
import Inbox from "./pages/Inbox";

// Portal pages
import PortalLogin from "./pages/portal/PortalLogin";
import PortalSetup from "./pages/portal/PortalSetup";
import PortalDashboard from "./pages/portal/PortalDashboard";
import PortalLongTerm from "./pages/portal/PortalLongTerm";
import PortalBookings from "./pages/portal/PortalBookings";
import PortalInvoices from "./pages/portal/PortalInvoices";
import PortalDamages from "./pages/portal/PortalDamages";
import PortalTickets from "./pages/portal/PortalTickets";
import PortalProfile from "./pages/portal/PortalProfile";

function App() {
  return (
    <AuthProvider>
      <PortalAuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/aktivieren/:token" element={<InstanceSetup />} />
            <Route path="/login" element={<Login />} />
            <Route path="/payments/success" element={<PaymentSuccess />} />
            <Route path="/card/:token" element={<BookingCard />} />
            <Route path="/registrieren" element={<RegisterStart />} />
            <Route path="/onboarding/:token" element={<PublicOnboarding />} />
            <Route path="/buchen" element={<PublicBooking />} />

            {/* Kunden-Portal */}
            <Route path="/portal/login" element={<PortalLogin />} />
            <Route path="/portal/setup/:token" element={<PortalSetup />} />
            <Route path="/portal" element={<PortalLayout />}>
              <Route index element={<PortalDashboard />} />
              <Route path="long-term" element={<PortalLongTerm />} />
              <Route path="bookings" element={<PortalBookings />} />
              <Route path="invoices" element={<PortalInvoices />} />
              <Route path="damages" element={<PortalDamages />} />
              <Route path="tickets" element={<PortalTickets />} />
              <Route path="profile" element={<PortalProfile />} />
            </Route>
          
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/" element={<Layout />}>
            <Route path="anbieter" element={<ProviderDashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="vehicles" element={<Vehicles />} />
            <Route path="vehicles/:id" element={<VehicleDetail />} />
            <Route path="maintenance" element={<Maintenance />} />
            <Route path="customers" element={<Customers />} />
            <Route path="customers/:id" element={<CustomerDetail />} />
            <Route path="bookings" element={<Bookings />} />
            <Route path="bookings/new" element={<Bookings key="new-booking" createNew />} />
            <Route path="bookings/:id" element={<BookingDetail />} />
            <Route path="calendar" element={<CalendarPage />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="quotes" element={<Quotes />} />
            <Route path="stations" element={<Stations />} />
            <Route path="categories" element={<Categories />} />
            <Route path="damages" element={<Damages />} />
            <Route path="cashbook" element={<Cashbook />} />
            <Route path="deposits" element={<Deposits />} />
            <Route path="supplier-settlements" element={<SupplierSettlements />} />
            <Route path="tickets" element={<TrafficTickets />} />
            <Route path="customer-onboardings" element={<CustomerOnboardings />} />
            <Route path="letters" element={<Letters />} />
            <Route path="accidents" element={<Accidents />} />
            <Route path="documents" element={<Documents />} />
            <Route path="long-term" element={<LongTermContracts />} />
            <Route path="long-term/:id" element={<LongTermContractDetail />} />
            <Route path="dunning" element={<Dunning />} />
            <Route path="datev" element={<DatevExport />} />
            <Route path="inbox" element={<Inbox />} />
            <Route path="inquiries" element={<Inquiries />} />
            <Route path="messages" element={<Messages />} />
            <Route path="emails" element={<Emails />} />
            <Route path="reports" element={<Reports />} />
            <Route path="settings" element={<Settings />} />
            <Route path="settings/integrations/whatsapp" element={<IntegrationWhatsApp />} />
            <Route path="scan/:token" element={<ScanPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </PortalAuthProvider>
      <Toaster 
        position="top-right" 
        richColors 
        toastOptions={{
          style: {
            borderRadius: '2px',
            fontFamily: 'IBM Plex Sans, sans-serif'
          }
        }}
      />
    </AuthProvider>
  );
}

export default App;
